import { render, staticRenderFns } from "./EncuestaPreguntasProlipa.vue?vue&type=template&id=38bf0422&scoped=true"
import script from "./EncuestaPreguntasProlipa.vue?vue&type=script&lang=js"
export * from "./EncuestaPreguntasProlipa.vue?vue&type=script&lang=js"
import style0 from "./EncuestaPreguntasProlipa.vue?vue&type=style&index=0&id=38bf0422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bf0422",
  null
  
)

export default component.exports